/* Atelier — common questions accordion (one answer open at a time). */
if (!customElements.get('atelier-faq')) {
  customElements.define(
    'atelier-faq',
    class AtelierFaq extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.addEventListener('click', (event) => {
          const toggle = event.target.closest('[data-faq-toggle]');
          if (!toggle || !this.contains(toggle)) return;
          const isOpen = toggle.getAttribute('aria-expanded') === 'true';
          this.openOnly(isOpen ? null : toggle);
        });
        // Theme editor: open the question whose block is selected.
        this.addEventListener('shopify:block:select', (event) => {
          const toggle = event.target.querySelector('[data-faq-toggle]');
          if (toggle) this.openOnly(toggle);
        });
      }

      toggles() {
        return Array.from(this.querySelectorAll('[data-faq-toggle]'));
      }

      openOnly(target) {
        this.toggles().forEach((toggle) => {
          const open = toggle === target;
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          const answer = document.getElementById(toggle.getAttribute('aria-controls'));
          if (answer) answer.hidden = !open;
        });
      }
    }
  );
}
